var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAgape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_458_50750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0953 26.9173C20.2188 27.166 26.1952 21.5929 26.444 14.4694C26.6927 7.34588 21.1196 1.36946 13.9961 1.12071C6.87259 0.871947 0.89618 6.44505 0.647421 13.5686C0.398663 20.6921 5.97175 26.6685 13.0953 26.9173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.664 11.8048C13.6748 10.9778 13.4841 14.4741 13.4841 14.4741C13.4841 14.4741 13.5379 10.9685 10.4981 11.5894C7.96952 12.1048 8.52342 15.755 9.81068 17.1307C10.6616 18.0384 13.2873 20.1102 13.2873 20.1102C13.2873 20.1102 16.0556 18.2268 16.9632 17.3805C18.3434 16.0934 19.1506 12.4907 16.664 11.8048Z",
    fill: "#FF5C7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6466 9.81997C13.5279 9.81582 13.4399 9.71673 13.4439 9.60254L13.5067 7.80299C13.5108 7.68424 13.61 7.59625 13.7241 7.60023C13.8429 7.60438 13.9309 7.70348 13.9269 7.81766L13.8641 9.61722C13.8646 9.73156 13.7654 9.82412 13.6466 9.81997Z",
    fill: "#FF5C7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8258 10.271C15.7847 10.2696 15.7485 10.2592 15.7128 10.235C15.6145 10.1676 15.5917 10.0342 15.659 9.9405L16.6848 8.4581C16.7523 8.35986 16.8857 8.33707 16.9794 8.40436C17.0776 8.47181 17.1004 8.60523 17.0331 8.69891L16.0073 10.1813C15.964 10.2438 15.8944 10.2734 15.8258 10.271Z",
    fill: "#FF5C7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.738 10.1283C11.6695 10.126 11.6023 10.087 11.5633 10.0262L10.6434 8.47587C10.5829 8.37315 10.6148 8.24621 10.7175 8.18578C10.8202 8.12534 10.9471 8.15722 11.0076 8.25994L11.9275 9.81028C11.9879 9.91299 11.956 10.0399 11.8533 10.1004C11.8206 10.1221 11.7791 10.1298 11.738 10.1283Z",
    fill: "#FF5C7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3024 11.0385C10.2659 11.0372 10.2251 11.0266 10.1893 11.0025L8.69732 9.99006C8.59907 9.92261 8.57613 9.79377 8.63902 9.69536C8.70647 9.59711 8.83532 9.57418 8.93373 9.63706L10.4257 10.6495C10.524 10.7169 10.5469 10.8458 10.484 10.9442C10.4453 11.0068 10.3755 11.041 10.3024 11.0385Z",
    fill: "#FF5C7B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8977 11.2687C16.8292 11.2663 16.7574 11.2272 16.7231 11.162C16.6626 11.0593 16.6991 10.9325 16.8018 10.8721L18.3608 9.96623C18.4635 9.90579 18.5903 9.94223 18.6507 10.0449C18.7111 10.1477 18.6747 10.2744 18.572 10.3349L17.013 11.2407C16.9757 11.2623 16.9388 11.2702 16.8977 11.2687Z",
    fill: "#FF5C7B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.48683,
    y: 1.08743,
    width: 25.0056,
    height: 25.0056,
    rx: 12.5028,
    transform: "rotate(2 1.48683 1.08743)",
    stroke: "#F3F3F3",
    strokeWidth: 0.806634
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_458_50750"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.09784,
    y: 0.670288,
    width: 25.8123,
    height: 25.8123,
    rx: 12.9061,
    transform: "rotate(2 1.09784 0.670288)",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgape);
export default __webpack_public_path__ + "static/media/Agape.fba0500ba44cb8f07ca52da3452e34aa.svg";
export { ForwardRef as ReactComponent };